import ReactMarkdown from 'react-markdown'; // Import the library
import React, { useState, useRef, useEffect } from 'react';
import './css/Result.css';
import '../pages/History.css';
import { useNavigate } from 'react-router-dom';



const fetchResults = async (youtubeLink, setResultData, setIsLoading, setError, navigate, setTypedText, setLastTypedIndex) => {
  setError('');
  setIsLoading(true);
  // Store the result in localStorage so it can be re-used on refresh
  // localStorage.setItem("searchResult", JSON.stringify(finalResult));
  // localStorage.setItem("lastSearchedLink", youtubeLink);
  
  // localStorage.removeItem("searchResult");
  // localStorage.removeItem("lastSearchedLink");
  
  
  try {
    // Retrieve and parse user-info from local storage
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const t = userInfo?.token;
    // console.log("token is :", t);
    
    
    // Counter logic for non-login users (no userInfo)
    if (!t) {
      let counterData = JSON.parse(localStorage.getItem("request-counter")) || { count: 0};


      // Check if user has remaining requests
      if (counterData.count >= 5) {
        alert("You have used your 1 free video analysis. Do register and get 5 free video analysis.");
        navigate("/signup");
        setError("You have used your 1 free video analysis. Do register and get 5 free video analysis.");
        setIsLoading(false);
        return;
      }
    }

    // Determine the endpoint and bodyData based on token presence
    const url = t
      ? `${process.env.REACT_APP_BACKEND_URL}/analysis/token`
      : `${process.env.REACT_APP_BACKEND_URL}/analysis/no-token`;

    const bodyData = t
      ? { video_url: youtubeLink, t: t }
      : { video_url: youtubeLink };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });


    if (!response.ok) {
      const errorText = await response.text();
      setError(errorText || "Having trouble reading comments. Please try after some time.");
      setIsLoading(false);
      console.error("Streaming error:", errorText);
      if (response.status === 429) {
        alert(errorText || "Rate limit exceeded.");
        navigate(t ? "/request-access" : "/signup");
      }
      return;
    }
    setResultData(null); // Reset result data before starting the stream
    setTypedText('');
    setLastTypedIndex(0); // Important for clean typing start
    // Start reading the streamed response
    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    let done = false;
    let finalResult = "";
    let combinedText= "";
    // setResultData(null);
    // setTypedText(null); // Reset typed text when fetching new results
  // setResultData('');
    // Reset before reading new result

    // setLastTypedIndex(0); // Reset last typed index when fetching new results
    // Continuously read from the stream until it's done (or we unmount)
    setIsLoading(false);
    setResultData(null); // Reset result data before starting the stream
    setTypedText('');
    setLastTypedIndex(0); // Important for clean typing start
    while (!done) {
      // Read a chunk from the stream
      const { value, done: readerDone } = await reader.read();
      // Update the done flag
      done = readerDone;
      if (value) {
        // Decode the binary chunk into text
        const chunkValue = decoder.decode(value, { stream: true });
        console.log("Chunk value:", chunkValue);
        finalResult += chunkValue;
        combinedText += chunkValue;
        console.log("Combined text:", combinedText);

        // Optionally update result in intervals
        setResultData(combinedText);
        
        // Append this chunk to our existing text
        // setResultData((prevText) => prevText + chunkValue);
      }
    }


  
    // Store the result in localStorage so it can be re-used on refresh
    localStorage.setItem("searchResult", JSON.stringify(finalResult));
    localStorage.setItem("lastSearchedLink", youtubeLink);

    // **Increment the count ONLY IF the response is successful**
    if (!t) {
      let counterData = JSON.parse(localStorage.getItem("request-counter")) || { count: 0 };
      counterData.count += 1;
      localStorage.setItem("request-counter", JSON.stringify(counterData));
    }

  } catch (error) {
    setError("Having trouble reading comments. Please try after some time.");
    setResultData(null);
  } finally {
    // setIsLoading(false);
  }
};


const fetchYouTubeTitle = async (youtubeLink, setTitle, setVideoId) => {
  const videoIdMatch = youtubeLink.match(
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([0-9A-Za-z_-]{11})/
  );
  const videoId = videoIdMatch ? videoIdMatch[1] : null;
  setVideoId(videoId); // Set the videoId state

  if (videoId) {
    try {
      const response = await fetch(`https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`);
      const data = await response.json();
      if (data && data.title) {
        setTitle(data.title);
      } else {
        setTitle("Title not available");
      }
    } catch (error) {
      console.error("Error fetching YouTube title:", error);
      setTitle("Title not available");
    }
  } else {
    setTitle("Invalid YouTube URL");
  }
};


const Result = ({ youtubeLink }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [resultData, setResultData] = useState('');
  const [resultData1, setResultData1] = useState('');
  const [error, setError] = useState('');
  const [title, setTitle] = useState('');
  const [language, setLanguage] = useState("English");
  const [topic, setTopic] = useState("");
  const [duration, setDuration] = useState(5);
  const [link, setlink] = useState('');
  const [script, setScript] = useState('');
  const [isFetchingScript, setIsFetchingScript] = useState(false); // Loading state
  const [progress, setProgress] = useState(0); // Progress bar
  const [videoId, setVideoId] = useState('');
  const [timer, setTimer] = useState(0);
  const [milliseconds, setMilliseconds] = useState(0);
  const bottomRef = useRef(null);
  const analysisRef = useRef(null);
  const containerRef = useRef(null);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
  const iframeSectionRef = useRef(null);
  const [hasScrolledToIframe, setHasScrolledToIframe] = useState(false);

  const [typedText, setTypedText] = useState('');
  const [lastTypedIndex, setLastTypedIndex] = useState(0);
  

  const navigate = useNavigate();
  //change here for to include shorts learn from line 91
  const getYouTubeEmbedURL = (url) => {
    // const videoIdMatch =
    //   url.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/) ||
    //   url.match(/youtu\.be\/([^?]+)/);
    const videoIdMatch = url.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([0-9A-Za-z_-]{11})/);
    return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null;
  };

  const generateScript = async () => {
    setIsFetchingScript(true);
    setProgress(0);
    // Simulate a 30-second loading bar
    let interval = setInterval(() => {
      setProgress((prev) => (prev < 100 ? prev + 3.33 : 100)); // Increments to reach 100% in ~30 seconds
    }, 1000);
    // const apiUrl = "http://127.0.0.1:8000/rewrite-transcript/";
    const apiUrl = "https://script-writer-backend.onrender.com/rewrite-transcript/";
  
    const requestData = {
      youtube_url: link,
      language: language,
      include_points: "", // Send extra topics if any
      exclude_points: "", // Empty for now, modify if needed
      user_feedback: "", // Empty for now, modify if needed
    };
  
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const responseData = await response.json();
      console.log("API Response:", responseData);
      setScript(responseData.rewritten_transcript);
      // Save the generated script along with its YouTube link in localStorage
      localStorage.setItem("generatedScript", JSON.stringify({
        youtubeLink: link,
        script: responseData.rewritten_transcript
      }));
    } catch (error) {
      console.error("Error generating script:", error);
      alert("Failed to generate script. Please try again.");
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setIsFetchingScript(false);
        setProgress(0);
      }, 1000); // Extra second to ensure smooth transition
    }
  };

  useEffect(() => {
    if (youtubeLink) {
      
      // Check if stored link matches the current youtubeLink
      const storedLink = localStorage.getItem("lastSearchedLink");
      const storedResult = localStorage.getItem("searchResult");

      if (storedLink === youtubeLink && storedResult) {
        // Load the stored result if it matches the current link
        setResultData(JSON.parse(storedResult));
        // setResultData(""); // Clear the resultData to show the animation
        // setIsLoading(true); // Set loading to true to show the animation
      } else {
        // Otherwise, call the API to fetch a new result
        // console.log("Result Data these are the things in state", resultData);
        // console.log("Typed Text before fetching these are the things in state", typedText);
        // console.log("index last before fetching these are the things in state", lastTypedIndex);
        // // setTypedText(''); // Reset typed text when fetching new results
        // setResultData(null); // Clear the resultData to show the animation
        // setTypedText(''); // Reset typed text when fetching new results
        // setLastTypedIndex(0); // Reset last typed index when fetching new results
        // console.log("Result Data after reseting ",resultData);
        // console.log("Typed Text after resetingt ", typedText);
        // console.log("Index after reseting ", lastTypedIndex);
        setIsLoading(true); // Set loading to true to show the animation


        fetchResults(youtubeLink, setResultData, setIsLoading, setError, navigate, setTypedText, setLastTypedIndex);
      }
      fetchYouTubeTitle(youtubeLink, setTitle, setVideoId);
      setlink(youtubeLink);

       // Also check if there's a stored generated script for this link
       const storedScriptData = localStorage.getItem("generatedScript");
       if (storedScriptData) {
         const { youtubeLink: scriptLink, script: storedScript } = JSON.parse(storedScriptData);
         if (scriptLink === youtubeLink) {
           setScript(storedScript);
         } else {
           setScript(''); // Clear script if the link has changed
         }
       } else {
         setScript('');
       }
    }
  }, [youtubeLink]);

  // Doosra useEffect: isLoading ke basis pe timer control
  useEffect(() => {
    let interval;

    if (isLoading) {
      setMilliseconds(0); // Jab loading shuru, reset timer
      interval = setInterval(() => {
        setMilliseconds(prev => prev + 30); // 10 ms har step mein add
      }, 10); // har 10 ms mein update
    } else {
      clearInterval(interval); // jab loading band, timer bhi band
    }

    return () => clearInterval(interval); // clean up jab component unmount ho
  
  }, [isLoading]);

  

  useEffect(() => {
    if (isLoading && analysisRef.current) {
      analysisRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isLoading]);

  // Handle scrolling
  useEffect(() => {
    if (shouldAutoScroll && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [resultData]);

  useEffect(() => {
    if (youtubeLink && iframeSectionRef.current && !hasScrolledToIframe) {
      iframeSectionRef.current.scrollIntoView({ behavior: 'smooth' });
      setHasScrolledToIframe(true);
    }
  }, [youtubeLink, hasScrolledToIframe]);
  

  // Detect user scroll position
  useEffect(() => {
    const container = containerRef.current;

    const handleScroll = () => {
      if (!container) return;

      const { scrollTop, scrollHeight, clientHeight } = container;

      // If user is near the bottom (adjust threshold as needed)
      const isNearBottom = scrollHeight - scrollTop - clientHeight < 100;

      setShouldAutoScroll(isNearBottom);
    };

    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);


  // useEffect(() => {
  //   console.log("lastTypedIndex updated:", lastTypedIndex);
  
  //   if (lastTypedIndex === 0) {
  //     // Do something once it's truly reset
  //      // Otherwise, call the API to fetch a new result
  //      console.log("Result Data these are the things in state", resultData);
  //      console.log("Typed Text before fetching these are the things in state", typedText);
  //      console.log("index last before fetching these are the things in state", lastTypedIndex);
  //      // setTypedText(''); // Reset typed text when fetching new results
  //      setResultData(null); // Clear the resultData to show the animation
  //      setTypedText(''); // Reset typed text when fetching new results
  //      setLastTypedIndex(0); // Reset last typed index when fetching new results
  //      console.log("Result Data after reseting ",resultData);
  //      console.log("Typed Text after resetingt ", typedText);
  //      console.log("Index after reseting ", lastTypedIndex);
  //      setIsLoading(true); // Set loading to true to show the animation


  //      fetchResults(youtubeLink, setResultData, setIsLoading, setError, navigate, setTypedText, setLastTypedIndex);
  //   }
  // }, [lastTypedIndex]);



  // useEffect(() => {
  //   if (!resultData) return;

  //   console.log('resultData', resultData);
  //   let index = lastTypedIndex;
  //   console.log("index here before", index);
  //   let typingTimeout;
    

  //   const typeNext = () => {
  //     if (index < resultData.length) {
  //       console.log(resultData[index]);

  //       setTypedText(prev => prev + resultData[index]);
  //       // console.log("typedText", typedText);
  //       // console.log("index", index);
  //       index++;
  //       setLastTypedIndex(index); // keep state in sync
  //       typingTimeout = setTimeout(typeNext, 20); // Adjust speed here
  //     }
  //   };

  //   typeNext(); // Start typing

  //   return () => clearTimeout(typingTimeout); // cleanup
  // }, [resultData]);



  const seconds = Math.floor(milliseconds / 1000);
  const ms = milliseconds % 1000; // bacha hua milliseconds

  const embedURL = getYouTubeEmbedURL(youtubeLink);



  const handlePrint = () => {
    window.print();
  };


  return (
    <div ref={iframeSectionRef} className="result-container">
      {youtubeLink ? (
        <div ref={analysisRef} className="">
          
          {error && <p style={{ color: 'red', marginTop: '15px' }}>{error}</p>}
          <h2 className="video-title">
          ▶️ {title}</h2>
          <div  >
            <div className='videoshow'>
              <iframe
                className='responsive-iframe'
                src={embedURL}
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            
            <div className="result-animation">
              {isLoading ? (
                
                <p></p>
                // <p>
                //   <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="34px" fill="#FFFFFF"><path d="M80-140v-320h320v320H80Zm80-80h160v-160H160v160Zm60-340 220-360 220 360H220Zm142-80h156l-78-126-78 126ZM863-42 757-148q-21 14-45.5 21t-51.5 7q-75 0-127.5-52.5T480-300q0-75 52.5-127.5T660-480q75 0 127.5 52.5T840-300q0 26-7 50.5T813-204L919-98l-56 56ZM660-200q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29ZM320-380Zm120-260Z"/></svg>
                //   Patience is the secret ingredient; <br></br>great reports take time to perfect.</p>
              ) :  (
                <p></p>
              )}
              {/* <p>Your food is cooking 🍲</p> */}
            </div>
          </div>
          
          <div  className="result-badges"> 
          <img
            src={`https://img.shields.io/youtube/views/${videoId}?style=for-the-badge&logoSize=10%20px&logo=Youtube&logoColor=%ffffff&label=Views&labelColor=%23fc0303&color=%23ffffff`}
            alt="YouTube Comment Count Badge"
          />
          <img
            src={`https://img.shields.io/youtube/likes/${videoId}?style=for-the-badge&logoSize=10%20px&logo=Youtube&logoColor=%ffffff&label=Likes&labelColor=%23fc0303&color=%23ffffff`}
            alt="YouTube Comment Count Badge"
          /> 
          <img
            src={`https://img.shields.io/youtube/comments/${videoId}?style=for-the-badge&logoSize=10%20px&logo=Youtube&logoColor=%ffffff&label=Comments&labelColor=%23fc0303&color=%23ffffff`}
            alt="YouTube Comment Count Badge"
          />
          </div>
          {isLoading && (
            <p className='times-font middle-align'>
              {/* Optional SVG icon here */}
              💡 Thinking and Reasoning... {seconds}.{ms.toString().padStart(3, '0')} seconds
            </p>
          )}
          <div className="result-text">
          <div ref={iframeSectionRef}>

            
            {/* <h2 className="middle-align gap-bottom"> 
                  <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="40px" viewBox="0 0 20 20" width="40px" fill="#FFFFFF"><g><rect fill="none" height="20" width="20" x="0"/></g><g><g><polygon points="12.5,8 13.29,6.28 15,5.5 13.29,4.72 12.5,3 11.74,4.72 10,5.5 11.74,6.28"/><polygon points="4,10 4.4,8.4 6,8 4.4,7.6 4,6 3.6,7.6 2,8 3.6,8.4"/><path d="M16.5,6c-1.07,0-1.84,1.12-1.35,2.14l-3.01,3.01c-0.52-0.25-0.99-0.14-1.29,0l-1.01-1.01C9.94,9.95,10,9.73,10,9.5 C10,8.67,9.33,8,8.5,8S7,8.67,7,9.5c0,0.23,0.06,0.45,0.15,0.64l-3.01,3.01C3.95,13.06,3.73,13,3.5,13C2.67,13,2,13.67,2,14.5 S2.67,16,3.5,16S5,15.33,5,14.5c0-0.23-0.06-0.45-0.15-0.64l3.01-3.01c0.52,0.25,0.99,0.14,1.29,0l1.01,1.01 C10.06,12.05,10,12.27,10,12.5c0,0.83,0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5c0-0.23-0.06-0.45-0.15-0.64l3.01-3.01 C16.89,9.35,18,8.56,18,7.5C18,6.67,17.33,6,16.5,6z"/></g></g></svg>
                    Analysis Report
                  </h2> */}
              
            {/* <ReactMarkdown className='times-font'>{resultData}</ReactMarkdown> */}
            <ReactMarkdown className='times-font'>{resultData}</ReactMarkdown> 
            {/* <ReactMarkdown className='times-font'>{typedText}</ReactMarkdown>  */}
            {/* <ReactMarkdown className='times-font'>{resultData}</ReactMarkdown> */}
            {/* <div ref={bottomRef} /> */}
                      
          </div>
          
            {isLoading ? (
              <>
              
               
                {/* <p className='result-animation times-font middle-align'> */}
       
                {/* <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M320-160h320v-120q0-66-47-113t-113-47q-66 0-113 47t-47 113v120ZM160-80v-80h80v-120q0-61 28.5-114.5T348-480q-51-32-79.5-85.5T240-680v-120h-80v-80h640v80h-80v120q0 61-28.5 114.5T612-480q51 32 79.5 85.5T720-280v120h80v80H160Z"/></svg> */}
                {/* 💡 Thinking and Reasoning...{seconds}.{ms.toString().padStart(3, '0')} seconds</p> */}
                
                {/* <img className='small-loaders' src="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZTlndGU4Nzh4amQyY3hwZHZsN2U4azR5anVjNmswanoycWh5MzlmcyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/uEMcDGLQQG8pbkXUnp/giphy.gif" alt="Loading..." /> */}
                {/* to be removed later */}
                {/* <TypingMarkdown resultData={resultData} /> */}
                <div className="result-text-container">

                  {/* <ReactMarkdown className='times-font'>{resultData}</ReactMarkdown> */}
                  {/* <ReactMarkdown className='times-font'>{typedText}</ReactMarkdown> */}
                
                </div>
                
              </>
            ) : resultData ? (
              <>
              
                
                <h2 className='middle-align'> 
                <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#FFFFFF"><path d="m239-160 40-159H120l15-60h159l51-202H186l15-60h159l39-159h59l-39 159h203l39-159h59l-39 159h159l-15 60H666l-51 202h159l-15 60H600l-40 159h-59l40-159H338l-40 159h-59Zm114-219h203l51-202H404l-51 202Z"/></svg>
                {/* <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="40px" viewBox="0 0 20 20" width="40px" fill="#FFFFFF"><g><rect fill="none" height="20" width="20" x="0"/></g><g><g><polygon points="12.5,8 13.29,6.28 15,5.5 13.29,4.72 12.5,3 11.74,4.72 10,5.5 11.74,6.28"/><polygon points="4,10 4.4,8.4 6,8 4.4,7.6 4,6 3.6,7.6 2,8 3.6,8.4"/><path d="M16.5,6c-1.07,0-1.84,1.12-1.35,2.14l-3.01,3.01c-0.52-0.25-0.99-0.14-1.29,0l-1.01-1.01C9.94,9.95,10,9.73,10,9.5 C10,8.67,9.33,8,8.5,8S7,8.67,7,9.5c0,0.23,0.06,0.45,0.15,0.64l-3.01,3.01C3.95,13.06,3.73,13,3.5,13C2.67,13,2,13.67,2,14.5 S2.67,16,3.5,16S5,15.33,5,14.5c0-0.23-0.06-0.45-0.15-0.64l3.01-3.01c0.52,0.25,0.99,0.14,1.29,0l1.01,1.01 C10.06,12.05,10,12.27,10,12.5c0,0.83,0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5c0-0.23-0.06-0.45-0.15-0.64l3.01-3.01 C16.89,9.35,18,8.56,18,7.5C18,6.67,17.33,6,16.5,6z"/></g></g></svg> */}
                  Sentiments (coming soon)</h2>


                  
                <div class="sentiment-wrapper ">


                    <div class="sentiment">
                      <svg class="donut-svg" width="120" height="60" viewBox="0 0 120 60">
                        <path d="M 10,60 A 50,50 0 0,1 110,60"
                              fill="none" stroke="#e6e6e6" stroke-width="10" />
                        <path d="M 10,60 A 50,50 0 0,1 110,60"
                              fill="none" stroke="#009900" stroke-width="10" 
                              stroke-dasharray="133 157" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#75CB4C" class="icon">
                        <path d="M626-533q22.5 0 38.25-15.75T680-587q0-22.5-15.75-38.25T626-641q-22.5 0-38.25 15.75T572-587q0 22.5 15.75 38.25T626-533Zm-292 0q22.5 0 38.25-15.75T388-587q0-22.5-15.75-38.25T334-641q-22.5 0-38.25 15.75T280-587q0 22.5 15.75 38.25T334-533Zm146 272q66 0 121.5-35.5T682-393h-52q-23 40-63 61.5T480.5-310q-46.5 0-87-21T331-393h-53q26 61 81 96.5T480-261Zm0 181q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"/>
                      </svg>
                      <div class="label">Positive
                        <br>
                        </br>
                        <span className='green-senti'>85%</span>
                      </div>
                    </div>

                    <div class="sentiment">
                      <svg class="donut-svg" width="120" height="60" viewBox="0 0 120 60">
                        <path d="M 10,60 A 50,50 0 0,1 110,60"
                              fill="none" stroke="#e6e6e6" stroke-width="10" />
                        <path d="M 10,60 A 50,50 0 0,1 110,60"
                              fill="none" stroke="#F9D010" stroke-width="10" 
                              stroke-dasharray="14 157" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#F9DB78" class="icon">
                        <path d="M626-533q22.5 0 38.25-15.75T680-587q0-22.5-15.75-38.25T626-641q-22.5 0-38.25 15.75T572-587q0 22.5 15.75 38.25T626-533Zm-292 0q22.5 0 38.25-15.75T388-587q0-22.5-15.75-38.25T334-641q-22.5 0-38.25 15.75T280-587q0 22.5 15.75 38.25T334-533Zm20 194h253v-49H354v49ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"/>
                      </svg>
                      <div class="label">Neutral
                      <br>
                        </br>
                        <span className='yellow-senti'>13%</span>
                      </div>
                    </div>


                    <div class="sentiment">
                      <svg class="donut-svg" width="120" height="60" viewBox="0 0 120 60">
                        <path d="M 10,60 A 50,50 0 0,1 110,60"
                              fill="none" stroke="#e6e6e6" stroke-width="10" />
                        <path d="M 10,60 A 50,50 0 0,1 110,60"
                              fill="none" stroke="#FF4D4D" stroke-width="10" 
                              stroke-dasharray="10 157" />
                      </svg>
                      {/* <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#ff4d4d" class="icon">
                        <path d="M480-80q-83 0-156-31.5t-127-86Q143-252 111.5-325T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 155.5 31.5t127 85.5q54.5 54 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-60q141 0 240.5-99.5T820-480q0-142-99.5-241T480-820q-142 0-241 99t-99 241q0 141 99 240.5T480-140Zm73-391 14-8q3 20 18 33t35 13q23 0 38.5-15.5T674-547q0-13-5.5-24T653-590l27-15-20-35-127 73 20 36Zm-146 0 20-36-127-73-20 35 27 15q-10 8-15.5 19t-5.5 24q0 23 15.5 38.5T340-493q20 0 35-13t18-33l14 8Zm73 94q-69 0-121 45.5T281-280h398q-27-65-78.5-111T480-437Z"/>
                      </svg> */}
                      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#ff4d4d" class="icon"><path d="M480-80q-83 0-156-31.5t-127-86Q143-252 111.5-325T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 155.5 31.5t127 85.5q54.5 54 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm73-451 14-8q3 20 18 33t35 13q23 0 38.5-15.5T674-547q0-13-5.5-24T653-590l27-15-20-35-127 73 20 36Zm-146 0 20-36-127-73-20 35 27 15q-10 8-15.5 19t-5.5 24q0 23 15.5 38.5T340-493q20 0 35-13t18-33l14 8Zm73 94q-69 0-121 45.5T281-280h398q-27-65-78.5-111T480-437Z"/></svg>
                      <div class="label">Negative
                      <br>
                        </br>
                        <span className='red-senti'>7%</span>
                      </div>
                    </div>

                </div>

                <p> <br></br> <br></br></p>

                


                {/* <span className="some-buttons"> */}
                
                {/* <TranslateButton /> */}
                {/* <button title='Translate' className="signup-btn middle-align " onClick={handleTranslateClick}>  
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m480-80-40-120H160q-33 0-56.5-23.5T80-280v-520q0-33 23.5-56.5T160-880h240l35 120h365q35 0 57.5 22.5T880-680v520q0 33-22.5 56.5T800-80H480ZM286-376q69 0 113.5-44.5T444-536q0-8-.5-14.5T441-564H283v62h89q-8 28-30.5 43.5T287-443q-39 0-67-28t-28-69q0-41 28-69t67-28q18 0 34 6.5t29 19.5l49-47q-21-22-50.5-34T286-704q-67 0-114.5 47.5T124-540q0 69 47.5 116.5T286-376Zm268 20 22-21q-14-17-25.5-33T528-444l26 88Zm50-51q28-33 42.5-63t19.5-47H507l12 42h40q8 15 19 32.5t26 35.5Zm-84 287h280q18 0 29-11.5t11-28.5v-520q0-18-11-29t-29-11H447l47 162h79v-42h41v42h146v41h-51q-10 38-30 74t-47 67l109 107-29 29-108-108-36 37 32 111-80 80Z"/></svg>
                </button> */}
                {/* <button title='delete this result' className="signup-btn middle-align " onClick={() => { window.open(resultData.pdf_link, "_blank"); }}>  
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/></svg>
                </button>
                <button 
                title='download as pdf' 
                className="signup-btn middle-align " 
                onClick={handleDownload}>  
                <svg  xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
                 </button>
                <button 
                title='download as pdf' 
                className="signup-btn middle-align " 
                onClick={handlePrint}>  
                <svg  xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
                 </button>
                </span> */}
                {/* <p>{resultData}</p> */}
                {/* <h2>Analysis Result</h2> */}
                {/* Use ReactMarkdown to beautify the markdown */}
                {/* <div className='result-text-container'> </div> */}

                {/* <ReactMarkdown className='times-font'>{typedText}</ReactMarkdown> */}

                {/* <ReactMarkdown className='times-font'>{resultData}</ReactMarkdown> */}
                
                {/* <p><strong>Analysis Result:</strong> {resultData.analysis_result}</p> */}
                
                {/* <div className="improve-section">
                    <h2>✧ Generate Similar Script on this topic</h2>
                  
    

                    <div className="input-group">
                      <label>Choose Language: {language}</label>
                      <select value={language} onChange={(e) => setLanguage(e.target.value)}>
                        <option>English</option>
                        <option>Hindi</option>
                        <option>Arabic</option>
                        <option>Bengali</option>
                        <option>Portuguese</option>
                        <option>Russian</option>
                        <option>Spanish</option>
                        <option>French</option>
                        <option>German</option>
                        <option>Chinese</option>
                        <option>Japanese</option>
                      </select>
                    </div>

                    <div className="input-group">
                      <label>Add your Topics: (optional)</label>
                      <input
                        type="text"
                        placeholder="Type your topic here..."
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                      />
                    </div>

                    <div className="input-group">
                      <label>Set Duration: {duration} min (optional)</label>
                      <input
                        type="range"
                        min="1"
                        max="60"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                      />
                    </div>

                    <div>
                      <button className="improve-btn" onClick={generateScript} disabled={isFetchingScript}>{isFetchingScript ? "✧ Generating..." : "✧ Generate Script on this topic"}</button>
                    </div>

                    <style jsx>{`
                      .improve-section {
                        color: white;
                        padding: 20px;
                        border-radius: 10px;
                      }
                      .input-group {
                        margin: 10px 0;
                      }
                      select,
                      input {
                        width: 100%;
                        padding: 8px;
                        margin-top: 5px;
                        border-radius: 5px;
                        border: none;
                        background: #444;
                        color: white;
                      }

                      input[type="range"] {
                        width: 100%;
                      }
                     `}</style>
                </div> */}

<div className="improve-section">
                    <h2>✧ Generate Key Takeaway</h2>
                  
    

                    <div className="input-group">
                      <label className="vertical-align">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="34px" fill="#e3e3e3"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/></svg>
                        Choose Language:{language}</label>
                      <select value={language} onChange={(e) => setLanguage(e.target.value)}>
                        <option>English</option>
                        <option>Hindi</option>
                        <option>Arabic</option>
                        <option>Bengali</option>
                        <option>Portuguese</option>
                        <option>Russian</option>
                        <option>Spanish</option>
                        <option>French</option>
                        <option>German</option>
                        <option>Chinese</option>
                        <option>Japanese</option>
                      </select>
                    </div>

                    {/* <div className="input-group">
                      <label>Add your Topics:</label>
                      <input
                        type="text"
                        placeholder="Type your topic here..."
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                      />
                    </div>

                    <div className="input-group">
                      <label>Set Duration: {duration} min</label>
                      <input
                        type="range"
                        min="1"
                        max="60"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                      />
                    </div> */}

                    <div>
                      <button className="improve-btn" onClick={generateScript} disabled={isFetchingScript}>{isFetchingScript ? "✧ Generating..." : "✧ Generate Key Takeaway"}</button>
                    </div>

                    <style jsx>{`
                      .improve-section {
                        color: white;
                        padding: 20px;
                        border-radius: 10px;
                      }
                      .input-group {
                        margin: 10px 0;
                      }
                      select,
                      input {
                        width: 100%;
                        padding: 8px;
                        margin-top: 5px;
                        border-radius: 5px;
                        border: none;
                        background: #444;
                        color: white;
                      }

                      input[type="range"] {
                        width: 100%;
                      }
                     `}</style>
                </div>

                {/* Progress Bar */}
                {isFetchingScript && (
                  <div className="progress-container">
                    <div
                      className="progress-bar"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                )}
                    


                {script && (
                      <div className="max-w-3xl w-full bg-gray-900 p-6 rounded-2xl shadow-lg times-font">
                        <ReactMarkdown className="prose prose-invert max-w-none">{script}</ReactMarkdown>
                      </div>
                  )}
               
              </>
            ) : (
              <>
              
                <p className='times-font middle-align'>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="34px" fill="#FFFFFF"><path d="M620-520q25 0 42.5-17.5T680-580q0-25-17.5-42.5T620-640q-25 0-42.5 17.5T560-580q0 25 17.5 42.5T620-520Zm-280 0q25 0 42.5-17.5T400-580q0-25-17.5-42.5T340-640q-25 0-42.5 17.5T280-580q0 25 17.5 42.5T340-520Zm140 100q-68 0-123.5 38.5T276-280h66q22-37 58.5-58.5T480-360q43 0 79.5 21.5T618-280h66q-25-63-80.5-101.5T480-420Zm0 340q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Z"/></svg>
                  No
                   
                  report to display.</p>
                  <div ref={bottomRef} />
                
                <div className="improve-section">
                    <h2>✧ Generate Key Takeaway</h2>
                  
    

                    <div className="input-group">
                      <label className="vertical-align">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="34px" fill="#e3e3e3"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/></svg>
                        Choose Language:</label>
                      <select value={language} onChange={(e) => setLanguage(e.target.value)}>
                        <option>English</option>
                        <option>Hindi</option>
                        <option>Arabic</option>
                        <option>Bengali</option>
                        <option>Portuguese</option>
                        <option>Russian</option>
                        <option>Spanish</option>
                        <option>French</option>
                        <option>German</option>
                        <option>Chinese</option>
                        <option>Japanese</option>
                      </select>
                    </div>

                    {/* <div className="input-group">
                      <label>Add your Topics:</label>
                      <input
                        type="text"
                        placeholder="Type your topic here..."
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                      />
                    </div>

                    <div className="input-group">
                      <label>Set Duration: {duration} min</label>
                      <input
                        type="range"
                        min="1"
                        max="60"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                      />
                    </div> */}

                    <div>
                      <button className="improve-btn" onClick={generateScript} disabled={isFetchingScript}>{isFetchingScript ? "✧ Generating..." : "✧ Generate Key Takeaway"}</button>
                    </div>

                    <style jsx>{`
                      .improve-section {
                        color: white;
                        padding: 20px;
                        border-radius: 10px;
                      }
                      .input-group {
                        margin: 10px 0;
                      }
                      select,
                      input {
                        width: 100%;
                        padding: 8px;
                        margin-top: 5px;
                        border-radius: 5px;
                        border: none;
                        background: #444;
                        color: white;
                      }

                      input[type="range"] {
                        width: 100%;
                      }
                     `}</style>
                </div>
                {/* Progress Bar */}
                {isFetchingScript && (
                  <div className="progress-container">
                    <div
                      className="progress-bar"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                )}
                    


                {script && (
                      <div className="max-w-3xl w-full bg-gray-900 p-6 rounded-2xl shadow-lg times-font">
                        <ReactMarkdown className="prose prose-invert max-w-none">{script}</ReactMarkdown>
                      </div>
                  )}
              </>
              
            )}
          </div>
        </div>
      ) : (
        <p></p>
      )}
      
    </div>
  );
};

export default Result;
